import styled from '@emotion/styled';
import { FC } from 'react';
import { MyReviewListProps } from '../../hooks';
import { card_container_style, card_section_style } from '../styles';
import { ProductReviewStatus } from 'api2/types';
import { IconArrowRight16 } from 'components/base/Icon';
import Image from 'components/base/Image';
import Link from 'components/base/Link';
import Text from 'components/base/Text';
import { gray100 } from 'styles/colors';
import { useTracker } from 'util/Tracker';

interface Props {
  item_info: MyReviewListProps;
  is_last: boolean;
}

const common_ubl = {
  navigation: 'my_review',
  object_type: 'button',
  object_section: 'tab_writed_review',
  object_id: 'writed_review_card',
};

/**
 * 작성한 리뷰 카드 컴포넌트
 * @component
 */
const CompletedCard: FC<Props> = ({ item_info, is_last }) => {
  const tracker = useTracker();
  const { product_info, review_info } = item_info;
  const is_display_limited =
    review_info.status === ProductReviewStatus.DELETED ||
    review_info.status === ProductReviewStatus.NORMAL_ATTACHMENT_DELETED;

  const handleCardClick = () => {
    tracker.addLog({
      ...common_ubl,
      category: 'click',
    });
  };

  return (
    <Link href={`/reviews/${review_info.id}`}>
      <SC.Container onClick={handleCardClick} is_last={is_last}>
        <div className='thumbnail'>
          <Image
            src={product_info.image_url}
            layout='fill'
            objectFit='cover'
            alt={`내가 작성한 리뷰 리스트 중 ${product_info.name}상품 이미지`}
          />
        </div>
        <div css={card_section_style}>
          <Text variant='body3' as='p' className='product_name'>
            {product_info.name}
          </Text>
          <Text variant='small1_regular' as='p' color='gray500' className='product_options'>
            {product_info.options}
          </Text>
          {is_display_limited && (
            <Text variant='small1_regular' color='red500'>
              리뷰 노출이 제한됐어요
            </Text>
          )}
        </div>
        <SC.ArrowIcon>
          <IconArrowRight16 width={20} height={20} />
        </SC.ArrowIcon>
      </SC.Container>
    </Link>
  );
};

export default CompletedCard;

const SC = {
  Container: styled.div<{ is_last: boolean }>`
    ${card_container_style}
    padding: 16px 0;
    border-bottom: ${({ is_last }) => (is_last ? 'none' : `1px solid ${gray100}`)};
  `,
  ArrowIcon: styled.div`
    margin-left: auto;
    align-self: center;
  `,
};
